/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { ButtonBase, Typography } from '@material-ui/core';
import { POI_ACTION_TYPES, WS_ACTION_TYPES } from '../../redux-saga/actionTypes/index';
import { Title } from '../index';
import { commands } from '../../constants/index';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: { general },
} = theme;

const {
  backCommand,
  closeCommand,
  waypointCollapseCommand,
  editStopsBackCommand,
  saveFavoriteCommand,
  editFavloadCommand,
  editRecentLoadCommand,
} = commands;
const poiListScreens = () => ['/', '/poiList'].includes(window.location.pathname);
const singlePoiScreens = () => ['/destinationInformation'].includes(window.location.pathname);
const mpScreens = () => ['/mp-information'].includes(window.location.pathname);
const moreInfoScreens = () => ['/more-information'].includes(window.location.pathname);
const routeScreens = () => ['/routes'].includes(window.location.pathname);
const editStopScreens = () => ['/edit-stop'].includes(window.location.pathname);
const waypointScreen = () => ['/waypoint-details'].includes(window.location.pathname);
const recentsScreen = () => ['/recents'].includes(window.location.pathname);
const favoritesScreen = () => ['/favorites'].includes(window.location.pathname);
const destinationsScreen = () => ['/destinations'].includes(window.location.pathname);
const fastRouteScreen = () => ['/fast-route'].includes(window.location.pathname);
const filterScreen = () => ['/filter'].includes(window.location.pathname);
const sortbyScreen = () => ['/sort-by'].includes(window.location.pathname);

class Header extends React.PureComponent {
  renderLeftButton = () => {
    const {
      singlePoi,
      routeInProgress,
      addStopInProgress,
      markPoiList,
      recentListInprogress,
      favoriteListInprogress,
      quicklinksInprogress,
      editListInprogress,
      classes,
    } = this.props;
    const buildButton = (icon, callback) => (
      <img src={icon} onClick={callback} className={classes.icons__left} alt="icon" />
    );
    let button = null;
    if (
      (poiListScreens() && !quicklinksInprogress) ||
      destinationsScreen() ||
      (singlePoiScreens() && singlePoi && !markPoiList && (addStopInProgress || !routeInProgress))
    ) {
      button = buildButton(general.Close, this.onClickClose);
    } else if (
      (favoritesScreen() && editListInprogress) ||
      (recentsScreen() && editListInprogress)
    ) {
      button = buildButton(general.Close, this.onClickCloseFavRecent);
    } else if (
      (singlePoiScreens() &&
        singlePoi &&
        markPoiList &&
        (!routeInProgress || addStopInProgress) &&
        !favoriteListInprogress &&
        !recentListInprogress &&
        !quicklinksInprogress) ||
      (singlePoiScreens() &&
        quicklinksInprogress &&
        markPoiList &&
        !recentListInprogress &&
        !favoriteListInprogress) ||
      filterScreen()
    ) {
      button = buildButton(general.ArrowBack, this.onClickBackToList);
    } else if (
      (routeScreens() && !routeInProgress) ||
      mpScreens() ||
      (moreInfoScreens() && (!routeInProgress || addStopInProgress)) ||
      fastRouteScreen()
    ) {
      button = buildButton(general.ArrowBack, this.onClickBackToDetails);
    } else if (
      (routeScreens() && routeInProgress) ||
      editStopScreens() ||
      (moreInfoScreens() && (routeInProgress || !addStopInProgress))
    ) {
      button = buildButton(general.ArrowBack, this.onClickBackToWaypoint);
    } else if (favoriteListInprogress && singlePoiScreens()) {
      button = buildButton(general.ArrowBack, this.onClickBackToFavorites);
    } else if (recentListInprogress && singlePoiScreens()) {
      button = buildButton(general.ArrowBack, this.onClickBackToRecents);
    } else if (
      (recentsScreen() && quicklinksInprogress && !editListInprogress) ||
      (favoritesScreen() && quicklinksInprogress && !editListInprogress) ||
      (poiListScreens() && quicklinksInprogress)
    ) {
      button = buildButton(general.ArrowBack, this.onClickBackToQuicklinks);
    } else if (sortbyScreen()) {
      button = buildButton(general.ArrowBack, this.onClickBackToFilter);
    }
    return button;
  };

  renderRightButton = () => {
    const { classes, list, editListInprogress, t, incomingStop, selectedPoi } = this.props;
    const buildButton = (icon, callback) => (
      <img src={icon} onClick={callback} className={classes.icons__right} alt="icon" />
    );
    const collapse = (
      <ButtonBase className={classes.collapse__border}>
        <img
          src={general.Collapse}
          className={classes.collapse__icon}
          onClick={this.onClickCollapse}
          alt="icon"
        />
      </ButtonBase>
    );
    let button = null;
    if (singlePoiScreens() && (!incomingStop.favorite || !selectedPoi.favorite)) {
      button = buildButton(general.FavoritesEmptyBlack, this.onClickFavorites);
    } else if (singlePoiScreens() && (incomingStop.favorite || selectedPoi.favorite)) {
      button = buildButton(general.FavoritesFilledRed);
    } else if (poiListScreens()) button = buildButton(general.Filter, this.onClickFilter);
    else if (waypointScreen()) button = collapse;
    else if ((favoritesScreen() || recentsScreen()) && list.length !== 0 && !editListInprogress) {
      button = buildButton(general.Edit, this.onClickEditList);
    } else if (filterScreen()) {
      button = (
        <Typography className={classes.clear} onClick={this.onClearFilter}>
          {t('filter.label.clear')}
        </Typography>
      );
    }
    return button;
  };

  onClickBackToList = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('poiList');
  };

  onClickBackToDetails = () => {
    const { sendMessageToSocket } = this.props;
    if (editStopScreens()) {
      sendMessageToSocket(editStopsBackCommand);
    } else {
      sendMessageToSocket(backCommand);
    }
    navigate('destinationInformation');
  };

  onClickBackToWaypoint = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('waypoint-details');
  };

  onClickBackToFavorites = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('favorites');
  };

  onClickBackToRecents = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('recents');
  };

  onClickBackToQuicklinks = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('destinations');
  };

  onClickClose = () => {
    const { sendMessageToSocket, reset } = this.props;
    sendMessageToSocket(closeCommand);
    reset();
    navigate('/');
  };

  onClickCollapse = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(waypointCollapseCommand);
  };

  onClickFavorites = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(saveFavoriteCommand);
  };

  onClickEditList = () => {
    const { sendMessageToSocket, setEditListFlag, favoriteListInprogress } = this.props;
    setEditListFlag(true);
    if (favoriteListInprogress) {
      sendMessageToSocket(editFavloadCommand);
    } else {
      sendMessageToSocket(editRecentLoadCommand);
    }
  };

  onClickCloseFavRecent = () => {
    const { setEditListFlag, sendMessageToSocket, dialogContinue, quickLinksEvent } = this.props;
    sendMessageToSocket(closeCommand);
    dialogContinue(() => {
      setEditListFlag(false);
      quickLinksEvent(true);
    });
  };

  onClickFilter = () => {
    navigate('filter');
  };

  onClickBackToFilter = () => {
    const { sendMessageToSocket } = this.props;
    sendMessageToSocket(backCommand);
    navigate('filter');
  };

  render() {
    const { header } = this.props.classes;
    return (
      <React.Fragment>
        <div className={header}>
          {this.renderLeftButton()}
          <Title title={this.props.title} subtitle={this.props.subtitle} />
          {this.renderRightButton()}
        </div>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  sendMessageToSocket: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  routeInProgress: PropTypes.bool,
  singlePoi: PropTypes.bool,
  addStopInProgress: PropTypes.bool,
  markPoiList: PropTypes.bool,
  list: PropTypes.array,
  setEditListFlag: PropTypes.func.isRequired,
  editListInprogress: PropTypes.bool,
  favoriteListInprogress: PropTypes.bool,
  recentListInprogress: PropTypes.bool,
  quicklinksInprogress: PropTypes.bool,
  quickLinksEvent: PropTypes.func.isRequired,
  dialogContinue: PropTypes.func.isRequired,
  selectedPoi: PropTypes.bool.isRequired,
  incomingStop: PropTypes.bool.isRequired,
};

Header.defaultProps = {
  title: '',
  subtitle: '',
  addStopInProgress: false,
  singlePoi: false,
  markPoiList: false,
  editListInprogress: false,
  favoriteListInprogress: false,
  recentListInprogress: false,
  quicklinksInprogress: false,
  routeInProgress: false,
  list: [],
};

const mapStateToProps = ({ poi }) => ({
  routeInProgress: poi.route_inprogress,
  singlePoi: poi.single_poi,
  addStopInProgress: poi.stops_inprogress,
  markPoiList: poi.poi_list_inprogress,
  list: poi.favorite_recent_list,
  editListInprogress: poi.edit_list_inprogress,
  favoriteListInprogress: poi.favorite_list_inprogress,
  recentListInprogress: poi.recent_list_inprogress,
  quicklinksInprogress: poi.quicklinks_inprogress,
  selectedPoi: poi.selected_poi,
  incomingStop: poi.incoming_stop,
});

const mapDispatchToProps = dispatch => ({
  reset: () => dispatch({ type: POI_ACTION_TYPES.POI_RESET }),
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  setEditListFlag: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.EDIT_LIST_INPROGRESS, payload }),
  dialogContinue: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_DIALOG_CONTINUE, payload }),
  quickLinksEvent: payload =>
    dispatch({ type: POI_ACTION_TYPES.QUICKLINKS_FROM_WS.SUCCESS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(Header)),
);
